import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Modal from "../modals/Modal";
import { useCookies } from "react-cookie";
import toast from "react-hot-toast";
import { postData } from "../../../services";
import { errorStyles, confimationStyles } from "../../../assets/styles/toast";
import InputLayout from "../../atoms/InputLayout";
import Error from "../../atoms/Error";
import TagInput from "../../molecules/TagInput";

const ClientDropdownModal = ({
  isOpen,
  onClose,
  onSubmit,
  refetchClientList,
}) => {
  const [cookies] = useCookies(["e_t"]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const res = await postData({
        endpoint: "Client/createClient",
        data: values,
        token: cookies.e_t,
      });

      if (res) {
        toast.success("Client Created", { style: confimationStyles });
        onSubmit({
          value: res?.data?.data?.client_id,
          label: values.name,
          name: values.name,
        });
        resetForm();
        refetchClientList();
      }
    } catch (err) {
      toast.error("Client Creation Failed", { style: errorStyles });
    } finally {
      setIsSubmitting(false);
      onClose(); // Close the modal regardless of success or failure
    }
  };

  return (
    <Modal isActive={isOpen} onClose={onClose} title="Add New Client">
      <Formik
        initialValues={{ name: "", email: null }}
        validationSchema={Yup.object().shape({
          name: Yup.string().required("Client name is required"),
          email: Yup.array()
            .typeError("Please add an email and press Enter")
            .of(
              Yup.string()
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .required("Email is required")
            )
            .min(1, "At least one Email is required")
            .required("At least one Email is required"),
        })}
        onSubmit={handleSubmit}
      >
        {({ errors, setFieldValue }) => (
          <Form>
            <div className="form-group">
              <label className="required-field">Client Name</label>
              <Field
                name="name"
                className={`${errors.name ? "is-invalid" : ""}`}
              />
              <InputLayout classes="mt-3">
                <label className="required-field">Email</label>
                <TagInput
                  placeholder="Add Email and Press Enter"
                  onChange={(values) => {
                    setFieldValue("email", values);
                  }}
                />
                <Error error={errors.email} />
              </InputLayout>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Creating..." : "Create Client"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ClientDropdownModal;
